import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

import { Option } from "~ui-components/components/atoms/option";

export const ReferenceLayerInput = ({ layers }) => {
	return (
		<FormControl>
			<InputLabel>Reference Layer</InputLabel>
			<Select
				name="layer"
				value={layers[0].id}>
				{layers.map(({ id, name }) => (
					<Option
						key={id}
						value={id}>
						{name}
					</Option>
				))}
			</Select>
			<FormHelperText>
				Select the layer with the reference features and choose how to select
				the area or features you want to use.
			</FormHelperText>
		</FormControl>
	);
};
